import { render } from "./EgmUploadedList.vue?vue&type=template&id=12a8b7bb&scoped=true"
import script from "./EgmUploadedList.vue?vue&type=script&lang=js"
export * from "./EgmUploadedList.vue?vue&type=script&lang=js"

import "./EgmUploadedList.vue?vue&type=style&index=0&id=12a8b7bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a8b7bb"]])

export default __exports__